namespace TabAurous.OMS {
    export interface LabourPriceListDetailsForm {
        PriceListId: Serenity.IntegerEditor;
        ProductId: Serenity.StringEditor;
        AttributeId: Serenity.StringEditor;
        ProcessId: Serenity.LookupEditor;
        FromWt: Serenity.DecimalEditor;
        ToWt: Serenity.DecimalEditor;
        FromDate: Serenity.DateEditor;
        ToDate: Serenity.DateEditor;
        PurStdRate: Serenity.DecimalEditor;
        SaleStdRate: Serenity.DecimalEditor;
        MarkUp: Serenity.DecimalEditor;
        Amount: Serenity.DecimalEditor;
    }

    export class LabourPriceListDetailsForm extends Serenity.PrefixedContext {
        static formKey = 'OMS.LabourPriceListDetails';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!LabourPriceListDetailsForm.init)  {
                LabourPriceListDetailsForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.StringEditor;
                var w2 = s.LookupEditor;
                var w3 = s.DecimalEditor;
                var w4 = s.DateEditor;

                Q.initFormType(LabourPriceListDetailsForm, [
                    'PriceListId', w0,
                    'ProductId', w1,
                    'AttributeId', w1,
                    'ProcessId', w2,
                    'FromWt', w3,
                    'ToWt', w3,
                    'FromDate', w4,
                    'ToDate', w4,
                    'PurStdRate', w3,
                    'SaleStdRate', w3,
                    'MarkUp', w3,
                    'Amount', w3
                ]);
            }
        }
    }
}
